export default {"src":"/_next/static/media/credit-card.77ca1a96.svg","height":24,"width":41,"blurWidth":0,"blurHeight":0};